let n;
const s = /* @__PURE__ */ new WeakMap();
function u() {
  n || (n = new ResizeObserver((e) => {
    for (const r of e) {
      const c = s.get(r.target), a = c != null ? c : [];
      if (a.length === 0)
        return;
      requestAnimationFrame(() => {
        for (const t of a)
          typeof t == "function" ? t(r) : t.current(r);
      });
    }
  }));
}
function o(e) {
  if (e === void 0)
    throw new Error("ResizeObserver is not defined.  Please call init()");
}
function b(e, r) {
  var a;
  o(n);
  const c = (a = s.get(e)) != null ? a : [];
  return s.set(e, c.concat(r)), n.observe(e), () => {
    o(n);
    const t = s.get(e), i = (t != null ? t : []).filter((l) => l !== r);
    s.set(e, i), i.length === 0 && (n.unobserve(e), s.delete(e));
  };
}
export {
  u as init,
  b as registerCallback
};
